import {Component, Directive, EventEmitter, Injector, Input, Output, QueryList, ViewChildren} from '@angular/core';

import {StringToStringMap} from "../../../../interfaces/string-string-map.interface";
import {CacheService} from "../../../../../services/sys/cache.service";
import {Hit} from "../../../../../services/model/hit";
import {QueryManagerService} from "../../../../../services/domain/query-manager.service";
import {SettingsService} from "../../../../../services/sys/settings.service";
import {Hits} from "../../../../../services/model/hits";
import {ApplicationService} from "../../../../../services/domain/application.service";
import {TablePositionStatus} from "../../../../../services/model/tablePositionStatus";
import {StaticsService} from "../../../../../services/sys/statics.service";
import {FilterValue} from "../../../../../services/model/filterValue";
import {TableSortableHeader} from "./model/tableSortableHeader";


@Component({
    selector: 'efast-table-sortable',
    templateUrl: 'efast-table-sortable.component.html',
    styleUrls: ['efast-table-sortable.component.css'],
    standalone: false
})

export class EfastTableSortableComponent {
    @Input() efastHits: Hits = null;
    @Input() efastIsShown: boolean = false;

    tableSortableHeaders: TableSortableHeader[] = new Array();
    headerLabels: StringToStringMap<string> = {};
    headerSortFields: StringToStringMap<string> = {};

    private settingsService: SettingsService;
    private queryManagerService: QueryManagerService;
    private applicationService: ApplicationService;
    private staticsService: StaticsService;
    private tablePositionStatus;
    private pdfPath: string;


    constructor(private cacheService: CacheService,
                private injector: Injector) {
        this.settingsService = this.injector.get(SettingsService);
        this.applicationService = this.injector.get(ApplicationService);
        this.queryManagerService = this.injector.get(QueryManagerService);
        this.staticsService = this.injector.get(StaticsService);
     }

    ngOnInit() {
       // let tableSortableHeader = new TableSortableHeader();
        this.tableSortableHeaders.push({
            label: this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONSearchHdrCol1'),
            sortField: this.staticsService.getSortColumn().PLANNAME,
            columnClass: 'table-padding-spec table-padding-spectable-plan-spec   afs-cursor-pointer  '
        });
        this.tableSortableHeaders.push({
            label: this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONSearchHdrCol2'),
            sortField: this.staticsService.getSortColumn().PLANYEAR,
            columnClass: 'table-padding-spec afs-cursor-pointer'
        });
        this.tableSortableHeaders.push({
            label: this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONSearchHdrCol3'),
            sortField: this.staticsService.getSortColumn().EINPN,
            columnClass: 'table-padding-spec table-einPN-spec afs-cursor-pointer'
        });
        this.tableSortableHeaders.push({
            label: this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONSearchHdrCol4'),
            sortField: this.staticsService.getSortColumn().DATERECEIVED,
            columnClass: 'table-padding-spec  afs-cursor-pointer'
        });
        this.tableSortableHeaders.push({
            label: this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONSearchHdrCol5'),
            sortField: this.staticsService.getSortColumn().PLANSPONSER,
            columnClass: 'table-padding-spec table-sponsor-spec   afs-cursor-pointer  '
        });
        this.tableSortableHeaders.push({
            label: this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONSearchHdrCol6'),
            sortField: this.staticsService.getSortColumn().CITYSTATE,
            columnClass: 'table-padding-spec  afs-cursor-pointer  '
        });
        this.tableSortableHeaders.push({
            label: this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONSearchHdrCol7'),
            sortField: this.staticsService.getSortColumn().PARTICIPANTSBOY,
            columnClass: 'table-padding-spec  afs-cursor-pointer  '
        });
        this.tableSortableHeaders.push({
            label: this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONSearchHdrCol8'),
            sortField: this.staticsService.getSortColumn().ASSETSEOY,
            columnClass: 'table-padding-spec  afs-cursor-pointer'
        });

        this.headerLabels['Col1'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONSearchHdrCol1');
        this.headerLabels['Col2'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONSearchHdrCol2');
        this.headerLabels['Col3'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONSearchHdrCol3');
        this.headerLabels['Col4'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONSearchHdrCol4');
        this.headerLabels['Col5'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONSearchHdrCol5');
        this.headerLabels['Col6'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONSearchHdrCol6');
        this.headerLabels['Col7'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONSearchHdrCol7');
        this.headerLabels['Col8'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONSearchHdrCol8');
        this.headerSortFields['Col1'] = this.staticsService.getSortColumn().PLANNAME;
        this.headerSortFields['Col2'] = this.staticsService.getSortColumn().PLANYEAR;
        this.headerSortFields['Col2'] = this.staticsService.getSortColumn().EINPN;

        this.pdfPath = this.settingsService.getServicePdfPath();
        this.tablePositionStatus = this.applicationService.getTablePositionStatus();
    }

    isAsc(): boolean {
        if (this.applicationService.getTablePositionStatus().sortDirection == this.staticsService.getDirection().DIRECTION_ASC) {
            return true;
        }
        else {
            return false;
        }
    }

    isSortColumnActive(col: string): boolean {
        let isActive: boolean= false;

        if (this.applicationService.getTablePositionStatus().sortField == col) {
            isActive = true;
        }
        return isActive;
    }

    pdfClicked(pdfFile: string) {
        window.open(this.pdfPath  + pdfFile);
    }

    onSort(col: string) {
        let tablePositionStatus: TablePositionStatus = this.applicationService.getTablePositionStatus();
        if (col == tablePositionStatus.sortField) {
            if (tablePositionStatus.sortDirection == this.staticsService.getDirection().DIRECTION_ASC) {
                tablePositionStatus.sortDirection = this.staticsService.getDirection().DIRECTION_DESC;
            } else {
                tablePositionStatus.sortDirection = this.staticsService.getDirection().DIRECTION_ASC;
            }
        }

        tablePositionStatus.sortField = col;
        tablePositionStatus.paginatorPos = "0";
        this.applicationService.setTablePositionStatus(tablePositionStatus);

        this.queryManagerService.refresh();
    }

}
